import * as Loads from 'react-loads';

import { Redirect, useParams } from 'react-router-dom';

import { ContainerGrid } from '~/components/layout/PageStructure';
import PageStructuredData from '~/components/meta/structured-data/PageStructuredData';
import PageTitle from '~/components/modules/pageTitle';
import React, { useEffect } from 'react';
import SEO from '~/components/meta/SEO';
import client from '~/utils/client';
import { htmlToText } from '~/utils/helpers';
import { PageSkeletonLoader } from '~/components/ui/molecules/skeleton-loaders/PageSkeletonLoader';
import webstoreTracker, {
  ContentGroups,
} from '~/helpers/trackers/webstoreTrackerWrapper';

const fetchData = async slug => {
  return await client.request(
    `
    query($slug: String!) {
      page(slug: $slug) {
        content
        seoDescription
        seoTitle
        title
      }
    }
  `,
    {
      slug,
    },
  );
};

const ContentPage = () => {
  const { slug } = useParams();
  const { response, isResolved } = Loads.useLoads('contentPage', fetchData, {
    variables: [slug],
  });

  useEffect(() => {
    webstoreTracker.tagGroup(ContentGroups.Page);
  }, []);

  if (isResolved && !response.page) {
    return <Redirect to="/404" />;
  }

  const { title, image, content, seoTitle, seoDescription } =
    response?.page || {};
  const seoTitleOutput = seoTitle || title;
  const seoDescriptionOutput = seoDescription || htmlToText(content);

  return (
    <PageSkeletonLoader ready={isResolved}>
      <SEO title={seoTitleOutput} description={seoDescriptionOutput} />
      {title && <PageTitle title={title} image={image} />}
      {content && (
        <ContainerGrid>
          <div
            className="rte mb-9 col-start-1 col-span-4 md:col-start-3 md:col-span-8 content-page-markup__wrapper"
            dangerouslySetInnerHTML={createMarkup(content)}
          />
        </ContainerGrid>
      )}
      <PageStructuredData url={window.location.href} title={title} />
    </PageSkeletonLoader>
  );
};

function createMarkup(content) {
  return { __html: content };
}

export default ContentPage;
